import * as React from 'react';

import { css, StyleSheet } from 'aphrodite';
import { colors, combineStyles, formStyles, mixins } from '@blend/consumer-components';

export interface FastForwardOptionsProps extends React.HTMLAttributes<HTMLSelectElement> {
  options: string[];
  optionName: string;
}

const defaultPadding = 14;

const styles = StyleSheet.create({
  select: combineStyles(formStyles.selectInputStyle, mixins.transition('all', 0.15, 'ease-in-out'), {
    // Hide IE select dropdown arrows
    '::-ms-expand': {
      display: 'none',
    },
    appearance: 'none',
    boxShadow: formStyles.boxShadow,
    width: '50%',
    padding: defaultPadding,
    font: 'inherit',
    color: 'inherit',
    borderWidth: 0,
  }),

  label: {
    width: '50%',
    padding: defaultPadding,
    borderRight: '1px solid #BCBFBF',
  },

  wrapper: {
    marginBottom: defaultPadding,
    background: colors.snowPlus2,
    borderRadius: 4,
    border: `1px solid ${colors.clayPlus1}`,
    padding: 1,
    display: 'flex',
    width: '100%',
  },
});

export default class FastForwardOptions extends React.Component<FastForwardOptionsProps> {
  render() {
    const { options, optionName, title, ...selectProps } = this.props;

    return (
      <div className={css(styles.wrapper)}>
        <span className={css(styles.label)}>{title}</span>
        <select
          {...selectProps}
          name={optionName}
          className={css(styles.select)}
          data-it={`it-FastForwardOption-${optionName}`}
        >
          {options.map(option => (
            <option key={option} value={option}>
              {option}
            </option>
          ))}
        </select>
      </div>
    );
  }
}
